import { render, staticRenderFns } from "./ManagementToolbar.vue?vue&type=template&id=480a0f13&scoped=true&"
var script = {}
import style0 from "./ManagementToolbar.vue?vue&type=style&index=0&id=480a0f13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480a0f13",
  null
  
)

export default component.exports